import "./vendor";
import "./assets/svg/svg-sprite";
import "./scss/styles.scss";
import "./common.blocks/api/api";
import "./common.blocks/index";
import "./vue/index";

function requireAll(r) {
  r.keys().forEach(r);
}

requireAll(require.context("./", true, /\.(html)$/));

